
import React from 'react';
import PageHeader from '../common/PageHeader';

const SegmentHeader = () => {
  return (
    <PageHeader 
      pageTitle="Segmentation" 
      mainTitle="Customer Segmentation"
      description="Analyze customer behavior across different market segments"
    />
  );
};

export default SegmentHeader;
